import { render, staticRenderFns } from "./WorkerPrice.vue?vue&type=template&id=2c54a0a0&scoped=true"
import script from "./WorkerPrice.vue?vue&type=script&lang=js"
export * from "./WorkerPrice.vue?vue&type=script&lang=js"
import style0 from "./WorkerPrice.vue?vue&type=style&index=0&id=2c54a0a0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c54a0a0",
  null
  
)

export default component.exports